// extracted by mini-css-extract-plugin
module.exports = {"body_wrapper":"style__body_wrapper__SD1NN","arrow_wrapper":"style__arrow_wrapper__pRciW","open":"style__open__aEVlj","link":"style__link__tdxj6"};